import { createFileRoute, Link, notFound, Outlet } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import {
  findCity,
  type Country,
} from "@/lib/gold-data";
import { cityHeadMeta } from "@/lib/seo";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";

export const Route = createFileRoute("/city/$country/$city")({
  parseParams: ({ country, city }) => {
    if (country !== "pakistan" && country !== "india") throw notFound();
    return { country: country as Country, city };
  },
  loader: ({ context, params }) => {
    const c = findCity(params.country, params.city);
    if (!c) throw notFound();
    void context.queryClient.prefetchQuery(goldRatesQueryOptions);
  },
  head: ({ params }) => {
    const city = findCity(params.country, params.city);
    const safeCity = { slug: params.city, name: city?.name ?? "City" };
    const head = cityHeadMeta(params.country, safeCity);
    // Canonical is a leaf decision (see canonicalCityPath) — TanStack
    // concatenates links without dedup, so emitting one here would ship a
    // second, competing canonical alongside the child's.
    return { meta: head.meta };
  },
  component: CityLayout,
  notFoundComponent: () => (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-20 text-center">
        <h1 className="text-2xl font-bold">City not found</h1>
        <p className="mt-2 text-muted-foreground">Try the country pages instead.</p>
        <div className="mt-4 flex gap-2 justify-center">
          <Link to="/pakistan" className="underline">Pakistan</Link>
          <Link to="/india" className="underline">India</Link>
        </div>
      </div>
    </Layout>
  ),
  errorComponent: ({ error }) => (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-20 text-center">
        <h1 className="text-2xl font-bold">Could not load rates</h1>
        <p className="mt-2 text-sm text-muted-foreground">{error instanceof Error ? error.message : String(error)}</p>
      </div>
    </Layout>
  ),
});

function CityLayout() {
  return <Outlet />;
}